<div class="modal-header">
  <h3 class="modal-title">Edit Comment</h3>
  <button class="fa fa-times" [mat-dialog-close]="" style="float: right;cursor: pointer;background: none;border:none"
    aria-hidden="true"></button>
</div>
<div class="modal-body modal-body-height">
  <label class="control-label fw">Comment</label>
  <span class="pull-right text-blue" (click)="selectedComment = []">Delete All</span>
  <mat-chip-grid #commentList>
    <ng-container *ngFor="let item of selectedComment">
      <mat-chip-row [selectable]="selectable" [removable]="removable" (removed)="removeComment(item)">
        {{item}}
        <mat-icon matChipRemove>x</mat-icon>
      </mat-chip-row>
    </ng-container>
    <input class="form-control form-control-sm mat-autodd-input border-bottom" #commentInput
      [formControl]="commentCntrl" [matAutocomplete]="commentAutocomplete"
      [matChipInputFor]="commentList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
      [matChipInputAddOnBlur]="addOnBlur" (matChipInputTokenEnd)="addComment($event)">
  </mat-chip-grid>
  <mat-autocomplete #commentAutocomplete="matAutocomplete"
    (optionSelected)="selectComment($event)">
    <mat-option *ngFor="let subType of searchedComment" [value]="subType">
      {{subType}}
    </mat-option>
  </mat-autocomplete>
  <div class="mb-2 fg-g-red">
    <small *ngIf="!isAllow">Please enter at least one comment</small>
  </div>
</div>
<div class="modal-footer">
  <button class="btn bg-g-lightGreen btn-sm" (click)="updateComment()">Update</button>
</div>
